"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOptionWrapper = exports.StyledInfoAlert = exports.StyledGroup = exports.StyledDialogContent = exports.StyledActionDialog = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("../../../components");
const generic_1 = require("../../../generic");
exports.StyledActionDialog = (0, styled_components_1.default)(generic_1.ActionDialog) `
  .MuiDialog-paper {
    min-height: 85vh;
    width: calc(100vw - 64px);
    max-width: 60rem;
  }
`;
exports.StyledDialogContent = (0, styled_components_1.default)(generic_1.ActionDialogContent) `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2.5)};

  .autocomplete-tags-dropdown {
    max-height: 100px;
  }
`;
exports.StyledGroup = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  .title {
    text-transform: uppercase;
    color: ${ui_components_1.baseColors.primaryBlueDark500};
  }
`;
exports.StyledInfoAlert = (0, styled_components_1.default)(components_1.Alert) `
  display: flex;
  align-items: center;
  min-height: 60px;
  gap: ${({ theme }) => theme.spacing(0.5)};
  margin-top: auto;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 0;
  padding: ${({ theme }) => theme.spacing(2)};

  &.MuiAlert-outlinedInfo {
    background: none;
    border-color: ${ui_components_1.baseColors.primaryBlueMed200};

    .MuiAlert-icon {
      color: ${ui_components_1.baseColors.primaryBlueMed400};
    }
  }

  .MuiAlert-message {
    width: 100%;
  }
`;
exports.StyledOptionWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  width: 100%;

  svg {
    color: ${ui_components_1.baseColors.blue300};
  }
`;
